/* eslint-disable no-unused-vars */

export enum BannerType {
  PROFILE_HIDDEN = 'PROFILE_HIDDEN',
  ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND',
  NONE = '',
}

export enum GeneralErrorType {
  PROFILE_UNAVAILABLE = 'PROFILE_UNAVAILABLE',
  DEFAULT = 'DEFAULT',
  NONE = '',
}
